<template lang="pug">
  .form__rule-group
    div(
      :key="`rule-${index}`"
      v-for="(rule, index) in getRules"
    )
      p(
        class="text__and"
        v-if="index > 0 && getRules.length > 1"
      ) and
      Rule(
        :groupIndex="groupIndex"
        :ruleIndex="index"
      )
      span(
        class="button__remove-group"
        @click="removeRuleGroup(groupIndex)"
      )
        DeleteIcon(
          class="icon__close"
        )
    p.text__new(
      @click="addNewRule"
    ) Add New Rule
</template>
<script>
import store from '../../store';
import Rule from './Rule';
import DeleteIcon from 'vue-material-design-icons/Delete';
export default {
  name: 'ruleGroup',
  components: {
    DeleteIcon,
    Rule
  },
  props: {
    groupIndex: Number
  },
  computed: {
    getRules() {
        return store.getters.getActivePolicy.rules[this.groupIndex].groupRules;
    },
  },
  methods: {
    addNewRule() {
      let activePolicy = store.getters.getActivePolicy;
      activePolicy.rules[this.groupIndex].groupRules.push({});
    },
    removeRuleGroup(index) {
      console.log('clicking');
      let activePolicy = store.getters.getActivePolicy;
      activePolicy.rules.splice(index, 1);
      store.commit('setActivePolicy', activePolicy);
    }
  }
};
</script>
<style lang="scss" scoped>
.form__rule-group {
  background: #f5f5f5;
  padding: 0.5rem;
  margin-bottom: 2rem;
  position: relative;
}

.text__and {
  padding: 0 0.5rem;
  margin: 3px 0;
  font-style: italic;
}

p.text__new {
  color: #337ab7;
  // font-weight: bold;
  cursor: pointer;
  padding: 0.5rem;
  display: inline-block;
  margin-top: 0;
}
.button__remove-group {
  display: block;
  color: #777;
  position: absolute;
  right: -2rem;
  transition: all 0.2s;
  top: 0.5rem;

  &:hover {
    cursor: pointer;
    color: darken(#777, 10%);
  }

  .icon__close {
    font-size: 1.6rem;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/general/RuleGroup.vue